/**
 * The shell a signer sees: nothing at all, so the document can have the screen.
 * @file src/web/shared/SigningLayout.tsx
 *
 * PublicFormLayout centres a form in a column with our header above it. A
 * signer needs the opposite — the page edge to edge, especially on a phone —
 * and the signing page draws its own bar with the firm's name, progress and
 * the one button that matters. No guard (the token is the signer's whole
 * identity) and out of the index, like every link a client holds.
 *
 * @llm-rule AVOID: Adding navigation, sign-in or marketing here
 */
import { Outlet } from 'react-router-dom';
import { useSEO } from './hooks/useSEO';

export function SigningLayout() {
  useSEO({ title: 'Review and sign', description: 'A document sent to you to review and sign.', noindex: true });
  return (
    <div className="min-h-[100dvh] bg-muted/60">
      <Outlet />
    </div>
  );
}
